import helperModule from '../helper.module';

class ImageHelper {
    hasImageExtension(fileName) {
        return /.(bmp|gif|jpeg|jpg|png|svg)$/i.test(fileName);
    }
}

export default helperModule.service('imageHelper', ImageHelper);



// WEBPACK FOOTER //
// ./modules/helper/imageHelper/imageHelper.service.js